import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getRevyreDetailsDefaultState } from './constants';
import { GlobalDetailsState } from './types';

export const initialState: GlobalDetailsState = {
  tableParams: {},
  details: {},
  currentEntityId: '',
};

export const detailsSlice = createSlice({
  name: 'details',
  initialState,
  reducers: {
    setCurrentEntityId(
      state: GlobalDetailsState,
      action: PayloadAction<string>,
    ) {
      state.currentEntityId = action.payload;
    },
    setDetails(
      state: GlobalDetailsState,
      action: PayloadAction<GlobalDetailsState['details']>,
    ) {
      const { entityId, data, revyre } = action.payload;
      if (revyre) {
        const {
          detailsUIConfig,
          linkedReferralEntities,
          allowedActionsAndMetadata,
          mutatedEntity,
          profiles,
          accessAllowed,
        } = data?.payload ?? {};

        if (!state.details[entityId]) {
          state.details[entityId] = getRevyreDetailsDefaultState();
        }

        state.details[entityId].profileCardData.header =
          detailsUIConfig?.profileCardConfig?.header;
        state.details[entityId].profileCardData.body =
          detailsUIConfig?.profileCardConfig?.body;
        state.details[entityId].inputsMap = mutatedEntity;
        state.details[entityId].referredEntityDetails = linkedReferralEntities;
        state.details[entityId].allowedActions = allowedActionsAndMetadata;
        state.details[entityId].quickActions = detailsUIConfig?.actions;
        state.details[entityId].profiles = profiles;
        state.details[entityId].accessAllowed = accessAllowed;
      } else {
        state.details = {
          ...state.details,
          ...action.payload,
        };
      }
    },
    clearDetails(state: GlobalDetailsState) {
      state.details = {};
    },
    setDetailsActivitiesData(
      state: GlobalDetailsState,
      action: PayloadAction<{ entityId: string; data: any }>,
    ) {
      const { entityId, data } = action.payload;
      if (!state.details[entityId]) {
        state.details[entityId] = getRevyreDetailsDefaultState();
      }
      state.details[entityId].activities = data;
    },
    saveTableParams(
      state: GlobalDetailsState,
      action: PayloadAction<{
        filters?: Record<string, any>;
        sortBy?: string;
        sortType?: string;
      }>,
    ) {
      state.tableParams = {
        ...state.tableParams,
        ...action.payload,
      };
    },
    clearTableParams(state: GlobalDetailsState) {
      state.tableParams = {};
    },
  },
});

export const {
  saveTableParams,
  clearTableParams,
  setDetails,
  clearDetails,
  setDetailsActivitiesData,
  setCurrentEntityId,
} = detailsSlice.actions;

const reducer = { detailsModel: detailsSlice.reducer };

export default reducer;
